import { buildAuthFunctions } from '../helpers.js';

const authFunctions = buildAuthFunctions('candidates');

export default {
    changeOwner: authFunctions.manage,
    ...authFunctions,
};